import $ from '@vaersaagod/tools/Dom';
import Viewport from '@vaersaagod/tools/Viewport'

export default el => {
    const dom = $(el);
    const slides = dom.find('[data-slide]');
    const delay = 3;
    const duration = 1.5;
    const total = slides.length;

    let listening = false;
    let currentSlide = slides.eq(0);
    let nextSlide = slides.eq(1);
    let currentIndex = 0;
    let nextIndex = 1;

    const update = () => {
        currentSlide = nextSlide;
        currentIndex = nextIndex;
        nextIndex = currentIndex < (total - 1) ? currentIndex + 1 : 0;
        nextSlide = slides.eq(nextIndex);
        checkPosition();
    };

    const animate = () => {
        console.log('animate');
        new TimelineMax()
            .set(nextSlide.get(0), { xPercent: 100, display: 'block', zIndex: 9 })
            .set(nextSlide.find('[data-image]').get(0), { xPercent: -90 })
            .set(currentSlide.get(0), { zIndex: 8 })
            .to(currentSlide.get(0), duration, { xPercent: -20, clearProps: 'zIndex', ease: 'Quint.easeInOut' }, 0)
            .to(currentSlide.find('[data-image]').get(0), duration, { xPercent: 0.8 * 20, ease: 'Quint.easeInOut' }, 0)
            .to(nextSlide.find('[data-image]').get(0), duration, { xPercent: 0, ease: 'Quint.easeInOut' }, 0)
            .to(nextSlide.get(0), duration, { xPercent: 0, ease: 'Quint.easeInOut' }, 0)
            .call(update, null, null, delay);
    };

    const checkPosition = () => {
        if (Viewport.visible(el)) {
            if (listening) {
                listening = false;
                Viewport.off('scroll', checkPosition);
                setTimeout(checkPosition, delay * 1000);
            } else {
                animate();
            }
        } else if (!listening) {
            listening = true;
            Viewport.on('scroll', checkPosition);
        }
    };

    const init = () => {
        setTimeout(checkPosition, delay * 1000);
    };

    const destroy = () => {
        Viewport.off('scroll', checkPosition);
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/FrontSlideshow.js